import logo from './logo.svg';
import './App.css';

function App() {
  return ( <>

<div class="buttons">
  
  <button class="btnDup">Duplicate</button>
  <button id="del">Delete</button>
  <button class="btnDet">Details</button> 
  <button class="btnHead">Change Header</button>
  <button  class="btnBack">Change Background</button>
  
  </div>


    <div class="borders">
  <div class="card">
  <h2>Nick Singleton </h2> 

<img src= "https://www.si.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTkyMjQwNTI1ODcxNDI1MDcw/nicholas-singleton.jpg"alt="Nick Singleton" />
  
<div>
    <p class="body" >Star Football Runningback for the Penn State Nittany Lions!<br></br>Big Ten's Freshman of the Year in 2022</p>
    </div>
   
    </div>
  </div>


</> );
}

export default App;
